import { Hero } from "@/components/home/Hero";
import { GoogleReviews } from "@/components/home/GoogleReviews";
import { WhatWeDo } from "@/components/home/WhatWeDo";
import { ProcessSection } from "@/components/home/ProcessSection";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { ServiceAreas } from "@/components/home/ServiceAreas";
import { ServiceAreaMap } from "@/components/locations/ServiceAreaMap";
import { TruckParallax } from "@/components/home/TruckParallax";
import { UpdatesSection } from "@/components/home/UpdatesSection";
import { CTASection } from "@/components/home/CTASection";
import { RecentProjects } from "@/components/home/RecentProjects";
import { MidParallax } from "@/components/home/MidParallax";
import { InstantEstimateSection } from "@/components/shared/InstantEstimateSection";

const Index = () => {
  return (
    <>
      <main>
        <Hero />
        {/* <GoogleReviews /> */}
        <WhatWeDo />
        <ProcessSection />
        <MidParallax />
        <WhyChooseUs />
        <section className="py-12 lg:py-16 bg-muted">
          <div className="container mx-auto px-4">
            <ServiceAreaMap />
          </div>
        </section>
        <ServiceAreas />
        <TruckParallax />
        <UpdatesSection />
        <RecentProjects />
        <InstantEstimateSection />
        <CTASection />
      </main>
    </>
  );
};

export default Index;
